// extracted by mini-css-extract-plugin
module.exports = {"page":"articles-sub-hub_page__JwB4J"};